import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const SpaceNext = (props: IconProps) => (
  <Icon width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.39636 1.59339L5.39636 6.51447L1.39636 11.4355"
      stroke="black"
      strokeOpacity="0.6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
